<template>
  <div class="header-wrap" style="height:108px">
    <div class="header">
      <!-- <div class="header-top">
        <div class="w1200">
          <i>|</i>
          <span @click="changeLang" class="cur-pointer">{{ $t("message.changeLang") }}</span>
          <i>|</i>
        </div>
      </div> -->

      <div class="header-bottom" style="height: 108px;" @mouseleave="yiChu()">
        <div class="w1200" style="display: flex; justify-content: space-between; align-items: center;margin-top: 15px;">
          <div class="w1200-top" style="position: absolute; top: 55%; transform:translateY(-50%); right: 30px; opacity: 1; z-index: 99;">
            <span @click="changeLang" style=" color: rgb(128, 38, 40);" class="cur-pointer">{{ $t("message.changeLang") }}</span>
          </div>
          <router-link tag="span" to="/" class="cur-pointer">
            <img style="max-width: 177px; max-height: 80px; width: auto; height: auto; object-fit: contain;" class="logo" src="../assets/img/logo_top.png"  alt srcset />
          </router-link>
          <ul style="position: relative; overflow: visible;">
            <li
              v-for="(item,index) in navs"
              :key="index"
              :class="[index==2?'posit-show':'','cur-pointer']"
              @click="goPage(item,index)"  @mouseenter="yiRu(index)"
            >{{item.name}}</li>
            <!-- <div class="positOne" v-show="show==true" v-if="navs[2]">
              <div class="posit-top" v-for="(menu,index) in navs[2].children" :key="index">
                {{ menu.name }}
              </div>
            </div> -->
            <div v-if="this.$i18n.locale=='cn'" v-show="show==true" class="positOne" @mouseleave="yiChu()">
              <div class="box" v-if="this.navs[2]">
                <div  @click="jumpNew(menu)" :class="['posit-top']" v-for="(menu,index) in navs[2].children" :key="index">{{ menu.name }}</div>
              </div>
            </div>

            <div v-if="this.$i18n.locale=='en'"  v-show="show==true"  class="positOne" @mouseleave="yiChu()">
              <div class="box" v-if="this.navs[92]">
                <div  @click="jumpNew(menu)" :class="['posit-top']" v-for="(menu,index) in navs[92].children" :key="index">{{ menu.name }}</div>
              </div>
            </div>


          </ul>
        </div>
      </div>
    </div>
      <div class="header-phone-top">
        <router-link to="/" style="margin-right:auto">
          <img class="logo" style="width: 75px; background-size: 100% 100%;" src="../assets/img/logo_top.png" />
        </router-link>

        <!-- <img @click="toggleSearch" src="../assets/icon_search.png" />
        <span @click="changeLang">{{ $t("message.Language") }}</span>
        <Dropdown style="margin-left: 20px" placement="bottom-end" v-if="userInfo.UserName">
          <a href="javascript:void(0)" style="color:rgb(0, 35, 60);">
            {{userInfo.UserName}}
            <Icon type="arrow-down-b"></Icon>
          </a>
          <Dropdown-menu slot="list">
            <Dropdown-item v-for="(item,index) in userInfo.Systems" :key="index">
              <a style="color:rgb(0, 35, 60)" :href="item.Url">{{item.Name}}</a>
            </Dropdown-item>
            <Dropdown-item>
              <a @click="loginOut">退出</a>
            </Dropdown-item>
          </Dropdown-menu>
        </Dropdown>
        <img v-else @click="goLogin" src="../assets/icon_admin.png" /> -->
        <img style="width: 16px; height: 14px;" @click="toggleNavs" v-if="!showNavs" src="../assets/icon_menu.png" />
        <img style="width: 16px; height: 14px;" @click="toggleNavs" v-else src="../assets/icon_menu_close.png" />
      </div>
      <div class="header-phone-detail" v-if="showSearch || showNavs">
        <!-- <div class="header-phone-search cur-pointer" v-if="showSearch">
          <Input search v-model="searchValue">
            <Button
              @click="goSearch"
              type="info"
              slot="append"
              style="color:#fff;background-color: #2db7f5;border-color: #2db7f5;"
              icon="ios-search"
            >搜索</Button>
          </Input>
        </div> -->
        <div class="header-phone-navs" v-if="showNavs">
          <div class="w1200-top" style="margin-bottom: 5px;">
            <span @click="changeLang"  style="color: rgb(128, 38, 40);" class="cur-pointer">{{ $t("message.changeLang") }}</span>
          </div>
          <!-- <div class="types" v-if="this.$i18n.locale=='cn'"  v-show="show5==true">
            <div @click="jumpNew(menu)"  class="one" v-for="(menu,index) in this.navs[2].children" :key="index">{{ menu.name }}</div>
          </div>
          <div class="types" v-if="this.$i18n.locale=='en'"  v-show="show5==true">
            <div @click="jumpNew(menu)"  class="one" v-for="(menu,index) in this.navs[92].children" :key="index">{{ menu.name }}</div>
          </div> -->
          <div
            @click="goPage(item,index)"
            class="header-phone-nav cur-pointer"
            v-for="(item,key,index) in navs"
            :key="index"
          >
            <!-- <span>0{{index+1}}</span> -->
            {{item.name}}
          </div>
        </div>
        <div class="footer-bar" style="height: calc(100vh - 326px); background-color:opacity; position: absolute; z-index: 1;"></div>
      </div>
    </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      show5:false,
      showSearch: false,
      showNavs: false,
      searchValue: "",
      isLogin: false,
      navs: [],
      userInfo: {},
      show:false,
      index:'',
    };
  },
  created(){
    this.goPage()
  },
  mounted() {

    this.getMenu();
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    }
    this.$EventBus.$on("doLogin", (msg) => {
      // A发送来的消息
      console.log("userInfo", msg);
      localStorage.setItem("userInfo", JSON.stringify(msg));
      this.userInfo = msg;
    });
  },
  methods: {
    yiRu(index){
      if(index==2){
        this.show=!this.show
      }
      if(index==92){
        this.show=!this.show
      }

    },
    yiChu(){
      this.show=false

    },

    changeLang() {
      if (this.$i18n.locale == "cn") {
        this.$i18n.locale = "en";
      } else {
        this.$i18n.locale = "cn";
      }
    },
    toggleSearch() {
      this.showNavs = false;
      this.showSearch = !this.showSearch;
    },
    toggleNavs() {
      this.showNavs = !this.showNavs;
      this.showSearch = false;
    },
    //搜索
    goSearch() {
      this.showSearch = false;
      this.showNavs = false;
      this.$router.push("/search?keywords=" + this.searchValue);
    },
    goLogin() {
      this.$router.push("/login");
    },
    loginOut() {
      if (localStorage.getItem("userInfo")) {
        localStorage.removeItem("userInfo");
      }
      this.userInfo = "";

      this.$router.push("/login");
      return;
      let self = this;
      this.$axios.post(this.CusWebRoot + 'Cus/User/Login/SignOutApi').then(function (res) {
        console.log(res);
        self.$router.push("/login");
      });
    },
    //主导航
    getMenu() {
      let self = this;
      this.$axios
        .get(`/api/portal/navMenu/menu?lang=${this.$i18n.locale}&nav=main`)
        .then(function (res) {
          self.navs = res.data.data;
        });
    },
    goPage(item,i) {
      console.log(i,565656);

      // if(item.name=='客房及公寓'){
      //   this.show=!this.show
      // }
      // console.log(item,66666);
      this.showSearch = false;
      if(i!='1'){
        this.showNavs = false;
      }else{
        this.show5=!this.show5
        this.showNavs = false;

      }

      console.log(item,i,88888);
      this.index=i
      if (item.href.indexOf("http") > -1) {
        window.location.href = item.href;
        return;
      }
      let id = item.href.substr(-2);
      // console.log(item, id,'dadasdasdasdadsdaasda');

      // console.log(item.href.split('/')[4],55555555)
      id = id.replace("=", "");
      let name = item.name;
      if (item.name == "首页" || item.name == "HOME") {
        this.$router.push("/");
        return;
      }
      if(isNaN(id)){
        return
      }
      console.log(id, item.name);
      let self = this;

      if (item.lcj_type == "category") {
       let cates = document.getElementById('cates');
      //  cates.scrollIntoView(true);
      //  document.body.scrollTop=document.documentElement.scrollTop = cates.offsetTop - 90
        this.$axios
        .get(`/api/portal/categories/${(item.href.split('/')[4])}&lang=${this.$i18n.locale}`)
        .then(function(res) {
          console.log(res,88888);
        if(res.data.data.type == 'file'){
        self.$router.push(`/tabledownload?id=${item.href.split('/')[4]}&name=${name}`);
        }else{
          self.$router.push(`/news?id=${id}&name=${name}`);
          this.showNavs=false
            // if(i!='1'){
            //    self.$router.push(`/news?id=${id}&name=${name}`);
            // }else{

            // }
        }
        });
        this.$EventBus.$emit('goNav',id)
      }  else {
        // if(item.name=='客房'){
        //   this.$router.push("/rooms?id=" + item.href.split('/')[4]);

        // }
        // if(item.name=='餐饮'){
        //   this.$router.push("/repast?id=" + item.href.split('/')[4]);

        // }
        // if(item.name=='健身'){
        //   this.$router.push("/kepping?id=" + item.href.split('/')[4]);

        // }
        // if(item.name=='活动'){
        //   this.$router.push("/special?id=" + item.href.split('/')[4]);

        // }
        // if(item.name=='品牌'){
        //   this.$router.push("/detail?id=" + item.href.split('/')[4]);

        // }
        this.$router.push("/detail?id=" + item.href.split('/')[4]);

        // console.log(id,989898988989);
      }
    },
    jumpNew(menu){
      this.show5=false
      // console.log(menu.href.split('/')[4].split('=')[1],menu.name,666655555555);
      const id = menu.href.split('/')[4].split('=')[1]
      this.show=false
      this.showSearch = false;
      this.showNavs = false;
      this.$router.push(`/news?id=${id}&name=${menu.name}&name1=${menu.name}`);

    },
  },
  watch: {
    "$i18n.locale"() {
      this.getMenu();
      this.$router.push("/");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.header-wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 99999999;
  height: 80px;
}
.header {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 9999;
  box-shadow: -1px 6px 5px -2px rgba(0, 0, 0, 0.2);
}
.header-top {
  box-sizing: border-box;
  height: 48px;
  line-height: 48px;
  background: rgba(255, 255, 255, 1);
  color: #080404;
}
.header-top i {
  line-height: 48px;
  margin: 0px 16px;
}
.header-top span {
  line-height: 48px;
}
.header-top span img {
  vertical-align: sub;
}
.header-top .w1200 {
  font-size: 12px;
  text-align: right;
}
.header-bottom {
  height: 80px;
  box-sizing: border-box;
  line-height: 80px;
  background: rgba(255, 255, 255, 1);
  border-top: 1px solid #dbdbdb;
}
.header-bottom .logo {
  width: 24vw;
  // height: 45px;
  line-height: 80px;
  vertical-align: middle;
  max-width: 320px;
}
.header-bottom ul {
  float: right;
  overflow: hidden;
  // padding-top: 20px;
}
.header-bottom ul li {
  float: left;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 400;
  color: #080404;
  line-height: 25px;
  line-height: 80px;
}
.header-phone {
  display: none;

  .header-phone-top {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #fff;
    box-shadow: 0px 4px 16px 0px rgba(0, 35, 60, 0.08);
    padding: 0px 24px;
    z-index: 9999;

    img,
    span {
      margin-left: 16px;
    }
    img.logo {
      margin-right: auto;
      margin-left: 0px;
      height: 22px;
       vertical-align: middle;
    }
  }
  .header-phone-detail {
    position: fixed;
    top: 60px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height:220px;
    background: rgba(255, 255, 255, 1);
    z-index: 99999999999;
    .header-phone-search {
      background: #fff;
      padding: 16px;
    }
    .header-phone-navs {
      position: absolute;
      z-index: 999999999999;
      padding: 24px 0px 0px 24px;
      .header-phone-nav {
        font-size: 16px;
        font-weight: 600;
        line-height: 1.5;
        color: #212529;
        line-height: 56px;
        span {
          display: inline-block;
          font-size: 20px;
          transform: rotate(-90deg);
          font-weight: 300;
          color: rgba(0, 35, 60, 0.5);
          line-height: 31px;
        }
      }
    }
  }
}
@media (max-width: 1400px) {
  .header-phone-navs{
    margin-bottom: 50px!important;
  }
  .types{
    border-radius: 4px;
    padding: 5px;
    position: absolute;
    left:185px;
    background: #fff;
    top: 21%;
    .one{
      line-height: 26px;
    }
    .one:nth-child(1){
      border-bottom: 1px solid #e4e4e4;
    }
  }


  .header-phone-detail{
    position: fixed;
    z-index: 999999999;
    background: #fff;
    width: 100%;
    padding: 15px;
  }

  .logo{
    background-size: 100% 100%;
    width: 75px;
  }
  .header-phone-top{
    display: flex;
    height: 60px!important;
    align-items: center;
    padding: 0 24px;
  }
  .header-phone-nav {
    // height: 60px!important;
    // line-height: 60px!important;
    height: 30px!important;
    line-height: 30px!important;
  }

  .header-wrap {
    height: 60px!important;
    // position: fixed;
    // top: 0;
    // left: 0;
    // right: 0;
    // background: #fff;
    // z-index: 99999999;

  }
  .header {
    display: none;
  }
  .header-phone {
    display: block;
  }

}

// .posit-show:hover.positOne{
//   display: block!important;
// }

.positOne{
  position: absolute;
  background-color: #fff;
  top: 70%;
  left: 12%;
  width: 120px;
  height: 80px;
  padding: 4px 10px;
  z-index: 999999;
  .posit-top{
    height: 30px;
    cursor: pointer;
    line-height: 40px;
  }
  .posit-top:hover{
    color: red;
  }

}



</style>
